module.exports = __webpack_public_path__ + "img/static_page_banner.a1145d78.png";